const styles = () => ({
  container: {
    display: 'flex',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    flexShrink: '0',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  nav: {
    margin: 0,
    padding: 0,
    display: 'flex',
    fontSize: '18px',
    listStyle: 'none'
  }
})

export default styles
